import axios from '../../../../libs/axios'
import { AVAILABLE_YEARS } from '../../../../libs/constant'

export function getCommodityList(axiosPrivate){
  return axiosPrivate.get(`/trade-potential/commodities/KHM`)
}

export function getTradeDistributionData(hs, tradeflow, year){
  return axios.get(`/commodity/sayken-chart/${tradeflow}/KHM?hs_code=${hs}&year=${year}`)
}

export function getTradeHistoricalData(hs, tradeflow){
  return axios.get(`/commodity/historical-trade/${tradeflow}/KHM?hs_code=${hs}&year=2013-${AVAILABLE_YEARS[0]}`)
}
